import { Controller } from '@hotwired/stimulus';
import { GoogleCharts } from 'google-charts';

export default class extends Controller {
  static targets = ['line'];
  static values = {
    direction: String,
  };

  connect() {
    GoogleCharts.load(this.drawCharts.bind(this));
  }

  targetsVisible() {
    return this.lineTarget.offsetParent !== null;
  }

  drawCharts() {
    // Target elements are placed on a tab which may not be selected yet.
    // Wait until both targets are visible
    const checkExist = setInterval(() => {
      if (this.targetsVisible()) {
        this.drawLineCharts();

        clearInterval(checkExist);
      }
    }, 100);
  }

  drawLineCharts() {
    const data = JSON.parse(this.lineTarget.dataset.values);

    const lineData = new GoogleCharts.api.visualization.DataTable();
    lineData.addColumn('string', '');
    lineData.addColumn('number', '');
    lineData.addColumn({ type: 'string', role: 'annotation' });
    lineData.addRows(data);

    const lineOptions = {
      backgroundColor: 'transparent',
      legend: { position: 'none' },
      pointSize: 7,
      chartArea: {
        top: 10,
        width: '100%',
      },
      annotations: {
        textStyle: {
          color: this.onPrint() ? '#000' : '#fff',
        },
      },
      tooltip: {
        trigger: 'none',
      },
      hAxis: {
        textStyle: {
          fontSize: 13,
          color: '#bbb',
        },
      },
      vAxis: {
        gridlines: {
          count: 6,
          color: '#555',
        },
        minorGridlines: {
          color: '#555',
        },
        baselineColor: '#888',
        textStyle: {
          fontSize: 13,
          color: '#bbb',
        },
        viewWindow: {
          min: -6,
          max: 6,
        },
      },
    };

    if (this.directionValue == 'rtl') {
      lineOptions.chartArea.right = 98;
      lineOptions.series = {
        // Axis on the right
        0: { targetAxisIndex: 1, color: this.lineTarget.dataset.color },
        1: { targetAxisIndex: 1 },
      };
    } else {
      lineOptions.chartArea.left = 95;
      lineOptions.series = {
        // Axis on the left
        0: { color: this.lineTarget.dataset.color },
      };
    }

    const lineChart = new GoogleCharts.api.visualization.LineChart(
      this.lineTarget,
    );
    lineChart.draw(lineData, lineOptions);
  }

  onPrint() {
    return document
      .getElementsByTagName('body')[0]
      .classList.contains('js-print');
  }
}
